import { useInstance } from '../../support/ioc/useInstance';
import { Device } from '../../support/Device.ts';

// Pickers are buttons, but we want to align the text inside the button with its label,
// so we have to offset for the internal padding, which differs between ios/android!
export const PickerWrapper: React.FC<{children: React.ReactNode}> = ({ children }) => {
    const device = useInstance(Device);

    const iosStyle = { marginTop: -14, marginLeft: -19, marginBottom: -6 };
    const androidStyle = { marginTop: -8, marginLeft: -17, marginBottom: 0 };
    const style = device.mode === 'ios' ? iosStyle : androidStyle;

    return (
        <div style={style}>
            {children}
        </div>
    );
};
